<template>
    <div class="infoCard">
        <b-card class="general"> 
           
            <b-table-simple>
                <b-thead>
                    <b-th> {{$t('signal.panelUsers.orderNo')}} </b-th>
                    <b-th> {{$t('signal.panelUsers.name')}} </b-th>
                    <b-th> {{$t('signal.panelUsers.registerNo')}} </b-th>
                    <b-th> {{$t('signal.panelUsers.alarm')}} </b-th>

                </b-thead>
                <b-tbody>
                    <b-tr v-for="user in data.account_info.system_user" :key="user.id"> 
                        <b-td> {{user.order_no}} </b-td>
                        <b-td> {{user.name}}</b-td>
                        <b-td> {{user.register_no}} </b-td>
                        <b-td> 
                            <span v-if="user.alarm_type == 0 "> <b-icon icon="x" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> </span>
                            <span v-else-if="user.alarm_type == 1 ">  <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> {{$t('signal.panelUsers.activate')}} </span>
                            <span v-else-if="user.alarm_type == 2 ">  <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> {{$t('signal.panelUsers.outOfOrder')}} </span>
                            <span v-else> <b-icon icon="check" variant="success" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon> {{$t('signal.panelUsers.both')}} </span>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
     
    </div>
    
</template>

<script>
    export default {
        name: "PanelUser",
         props:{
            data: Object
        },
    }
</script>

<style scoped>
    @import "../styles/generalInfo.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Signal/components/PanelUsers.vue